import React from 'react';
import { connect } from 'react-redux';
import HighlightBanner from '@hpstellar/core/HighlightBanner';
import { withError } from '../../../shared/components/error-boundary';

import './value-prop-v2.less';

const ValuePropV2 = props => {
    const banner = props?.slugInfo?.components?.valuePropContentSpot?.highlightBanner;
    const width = props?.ui?.width;
    if (!banner) return null;
    return (
        <HighlightBanner
            className="valuePropV2"
            {...banner}
            cta={{
                ariaLabel: 'Shop',
                props: { color: 'white', href: banner?.cta?.href, variantion: 'secondary' },
                text: banner?.cta?.text,
            }}
            slim={width < 1024}
        />
    );
};

export default withError(connect(state => state, null)(ValuePropV2));
